import type { WebSockets } from '@pushflow/types'
import { retrieveLaunchParams } from '@telegram-apps/sdk-react'
import { useEffect, useState } from 'react'
import type { Options } from 'react-use-websocket'
import useWebSocket, { ReadyState } from 'react-use-websocket'

export const useAuthWebSocket = <GType extends { type: string }>(
  route: string | null,
  options?: Options,
) => {
  const { initDataRaw } = retrieveLaunchParams()
  const [isAuthorizied, setIsAuthorized] = useState<boolean>(false)
  const { sendJsonMessage, lastJsonMessage, ...ws } = useWebSocket<
    GType | WebSockets.AuthWebSocketOutputType
  >(`${import.meta.env.VITE_WS_URL}/${route}`, {
    ...options,
    shouldReconnect: () => !!route,
  })

  useEffect(() => {
    if (route === null || !initDataRaw || ws.readyState !== ReadyState.OPEN) {
      setIsAuthorized(false)
      return
    }

    const request: WebSockets.AuthWebSocketInputType = {
      type: 'auth',
      data: initDataRaw,
    }
    sendJsonMessage(request)
  }, [ws.readyState])

  useEffect(() => {
    if (lastJsonMessage === null) {
      return
    }
    if (lastJsonMessage.type === 'auth' && 'data' in lastJsonMessage) {
      setIsAuthorized(() => lastJsonMessage.status === 200)
    }
  }, [lastJsonMessage])

  return {
    ...ws,
    isAuthorizied,
    sendJsonMessage,
    lastJsonMessage,
  }
}
